import styled from "styled-components";
import { AccountLinkButtonTextAccountName } from "./buttonTexName";

export interface AccountLinkButtonTextProps {
  accountID: string;
  accountName?: string;
  isLoadingAccountName?: boolean;
  testId?: string;
}
const StyledAccountLink = styled.span`
  display: flex;
  align-items: center;
`;
const StyledAccountNameArea = styled.span`
  display: flex;
  align-items: center;
`;
export const AccountLinkButtonText = ({
  accountID,
  accountName,
  isLoadingAccountName,
  testId
}: AccountLinkButtonTextProps) => {
  const htmlSafeAccountId = accountID.replace(/[^a-zA-Z0-9]/g, "");
  return (
    <StyledAccountLink>
      <StyledAccountNameArea data-testid={testId}>
        {accountID}
        <AccountLinkButtonTextAccountName
          accountName={accountName}
          htmlSafeAccountId={htmlSafeAccountId}
          isLoadingAccountName={isLoadingAccountName}
        />
      </StyledAccountNameArea>
    </StyledAccountLink>
  );
};
